var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobeCertificateIcon = function SvgGlobeCertificateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21C7.029 21 3 16.971 3 12C3 7.029 7.029 3 12 3C16.971 3 21 7.029 21 12",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51001 9H20.38",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51001 15H12",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12C16 9.23599 15.277 6.47199 13.833 4.05999C12.986 2.64699 11.014 2.64699 10.168 4.05999C7.27799 8.88499 7.27799 15.116 10.168 19.941C10.591 20.647 11.296 21.001 12.001 21.001",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.244 17.379L17.688 18.935L16.755 18.001",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.22 18.652L14.751 19.347L14.866 20.212C14.93 20.692 15.307 21.07 15.787 21.134L16.654 21.25L17.348 21.78C17.732 22.074 18.266 22.074 18.65 21.78L19.345 21.249H19.344L20.21 21.134C20.69 21.07 21.068 20.693 21.132 20.213L21.248 19.346C21.248 19.347 21.517 18.995 21.779 18.652C22.073 18.268 22.073 17.734 21.779 17.35L21.248 16.655L21.133 15.79C21.069 15.31 20.692 14.932 20.212 14.868L19.344 14.753L18.65 14.223C18.266 13.929 17.732 13.929 17.348 14.223L16.653 14.753H16.654L15.788 14.867C15.308 14.931 14.93 15.308 14.866 15.788L14.75 16.655C14.75 16.654 14.481 17.006 14.219 17.349C13.927 17.734 13.927 18.267 14.22 18.652V18.652Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgGlobeCertificateIcon as ReactComponent };
export default __webpack_public_path__ + "globe-certificate-icon.svg";